export default "__VITE_ASSET__9PSn$f8M__"